import React from "react";

import "./PageTitle.css"

const PageTitle = () => {
  return (
      <div className={"page-title"}>
          <div style={{maxWidth: "500px", margin: "0 auto", textAlign: "center"}}>
                Welcome to What The FPL
          </div>
      </div>
  );
};

export default PageTitle;